module.exports = __webpack_public_path__ + "1792771649312/fonts/Rubik-Bold.9d63f81.ttf";